angular.module("avant.customer_applications.directives").directive "amountDateInput", ->
  restrict: 'A'
  require: 'ngModel'
  link: (scope, element, attributes, ngModelCtrl) ->

    model = scope.requirements[attributes.ngModel]
    maskDate = model?.mask_date

    modelSet = (value) ->
      return unless value
      dateArr = viewDateToArr(value)
      date = new Date(dateArr[2], dateArr[0], dateArr[1])
      date.setFullYear(dateArr[2])
      if isValidDate(date, dateArr)
        # to ensure date does not change when converted to iso date string based on time zone, getTimezoneOffset returns the offset in minutes
        iso_date = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString()
        return iso_date.slice(0, 10)
      else
        return value

    viewSet = (value, action) ->
      return unless value
      return value unless regexCheck(value, /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/)
      viewValue = value
      dateArr = isoDateToArr(viewValue)
      if maskDate && action != "focus"
        viewValue = "**/**/" + dateArr[2]
      else
        if model.date_type == "month_year"
          viewValue = dateArr[0] + "/" + dateArr[2]
        else
          viewValue = dateArr[0] + "/" + dateArr[1] + "/" + dateArr[2]
      return viewValue

    viewDateToArr = (value) ->
      if model.date_type == "month_year"
        year = value.slice(3, 7)
        month = parseInt(value.slice(0, 2)) - 1
        day = "01"
      else
        year = value.slice(6, 10)
        month = parseInt(value.slice(0, 2)) - 1
        day = value.slice(3, 5)
      dateArr = [month, day, year]
      return dateArr

    isoDateToArr = (value) ->
      year = value.slice(0, 4)
      month = value.slice(5, 7)
      day = value.slice(8, 10)
      dateArr = [month, day, year]
      return dateArr

    isValidDate = (date, dateArr) ->
      return date.getDate() == parseInt(dateArr[1]) &&
        date.getMonth() == parseInt(dateArr[0]) &&
        date.getFullYear() == parseInt(dateArr[2]) &&
        !isNaN(date)

    regexCheck = (value, regex) ->
      re = new RegExp(regex)
      re.test(value)

    # The parser needs to be at the end of the $parsers array, and the formatter
    # needs to be at the beginning of the $formatters array; otherwise
    # validations can run on the masked values
    ngModelCtrl.$parsers.push(modelSet)
    ngModelCtrl.$formatters.unshift(viewSet)

    element.bind "blur", =>
      element.val(viewSet(ngModelCtrl.$modelValue, "blur"))

    element.bind "focus", =>
      return unless ngModelCtrl.$modelValue
      element.val(viewSet(ngModelCtrl.$modelValue, "focus")).trigger('input')
